import { t } from 'i18next';
import { toast } from 'react-toastify';
import { TRANSLATE_REASONS } from '~/pages/Admin/ControlHistory/constants';
import { apiCall } from '~/providers';

export async function getReasonsList(state, render): Promise<void> {
  try {
    const filters = await apiCall('/remote-control/history-filters', {});
    state.reasonsListOpts = filters.REASONS?.map((item) => ({ name: TRANSLATE_REASONS[item.name], value: item.value }));
    state.changeListOpts = filters.CHANGES?.map((item) => ({ name: t(item.name), value: item.value }));
    render();
  } catch (err) {
    console.log(err);
    toast.error(t('erroReasons'));
  }
}
